import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sub-title',
    templateUrl: './sub-title.component.html',
    styleUrls: ['./sub-title.component.scss'],
    standalone: false
})
export class SubTitleComponent implements OnInit {
  @Input() direction: string = 'left';
  @Input() style: any = {};
  constructor() {}

  ngOnInit() {}
}
